module.exports = __webpack_public_path__ + "static/media/circle icon-3_new.75113107.png";